import { render, staticRenderFns } from "./BoolFilter.vue?vue&type=template&id=3b883498&scoped=true&"
import script from "./BoolFilter.vue?vue&type=script&lang=js&"
export * from "./BoolFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b883498",
  null
  
)

export default component.exports